import { bus } from "@/main";

export default {
	name: "HeaderBlock",
	data() {
		return {
			headerOpen: false,
			language: this.$route.params.lang,
			showMenu: false,
			isPlaying: false,
		}
	},
	props: [
		"images",
		"video"
	],
	created() {
		window.addEventListener("scroll", () => {
			this.evalScroll();
			this.evalHeaderScroll();
		});
		bus.$on("videoPlaying", (value) => {
			console.log("Video State : ", !value)
			this.isPlaying = !value;
		})
	},
	mounted() {
		this.evalHeaderScroll();
		// this.randomizeImages();
	},
	watch: {
		"$route": function () {
			this.language = this.$route.params.lang
		}
	},
	methods: {
		evalScroll() {
			let scroll = window.scrollY;
			let height = window.innerHeight / 2;

			if( scroll > height) {
				this.intro = false;
			} else {
				this.intro = true;
			}
		},
		evalHeaderScroll() {
			let elementHeight = this.$el.clientHeight;
			let scroll = window.scrollY;
			let height = window.innerHeight;
			
			if ((scroll + height) > elementHeight) {
				this.showMenu = true;
			} else {
				this.showMenu = false;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/header/header.block.js